import { render, staticRenderFns } from "./NsCarousel.vue?vue&type=template&id=100e9e67&scoped=true&"
import script from "./NsCarousel.vue?vue&type=script&lang=js&"
export * from "./NsCarousel.vue?vue&type=script&lang=js&"
import style0 from "./NsCarousel.vue?vue&type=style&index=0&id=100e9e67&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100e9e67",
  null
  
)

export default component.exports